import { render, staticRenderFns } from "./sellerConfirm.vue?vue&type=template&id=75858c8c&scoped=true"
import script from "./sellerConfirm.vue?vue&type=script&lang=js"
export * from "./sellerConfirm.vue?vue&type=script&lang=js"
import style0 from "./sellerConfirm.vue?vue&type=style&index=0&id=75858c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75858c8c",
  null
  
)

export default component.exports